<div class="generic-information-template">
<div class="informaton-container">
  <div class="row text-center">
    <div class="col">
      <div class="header-icon full-icon">
          <svg-information-color-svg></svg-information-color-svg>
      </div>
      <h1 class="title-copy">{{ 'INFORMATION' | translate }}</h1>
    </div>
  </div>

  <div class="information-link-container">
    <a [routerLink]="['about']" class="padding-vertical pv16 home-list d-block border-bottom" mdbRipple>
      <div class="link-contents">
        <div><strong>{{ 'INFORMATION_HOME_1' | translate }}</strong></div>
        <div class="row">
          <div class="col information-description">{{ 'INFORMATION_HOME_2' | translate }}</div>
          <div class="col-auto icon-container"><i class="material-icons">keyboard_arrow_right</i></div>
        </div>
      </div>
    </a>

    <a [routerLink]="['products']" class="padding-vertical pv16 home-list d-block border-bottom" mdbRipple>
      <div class="link-contents">
        <div><strong>{{ 'INFORMATION_HOME_3' | translate }}</strong></div>
        <div class="row">
          <div class="col information-description">{{ 'INFORMATION_HOME_4' | translate }}</div>
          <div class="col-auto icon-container"><i class="material-icons">keyboard_arrow_right</i></div>
        </div>
      </div>
    </a>

    <a [routerLink]="['discounts']" class="padding-vertical pv16 home-list d-block border-bottom" mdbRipple>
      <div class="link-contents">
        <div><strong>{{ 'INFORMATION_HOME_5' | translate }}</strong></div>
        <div class="row">
          <div class="col information-description">{{ 'INFORMATION_HOME_6' | translate }}</div>
          <div class="col-auto icon-container"><i class="material-icons">keyboard_arrow_right</i></div>
        </div>
      </div>
    </a>

    <a [routerLink]="['renewal']" class="padding-vertical pv16 home-list d-block border-bottom" mdbRipple>
      <div class="link-contents">
        <div><strong>{{ 'INFORMATION_HOME_7' | translate }}</strong></div>
        <div class="row">
          <div class="col information-description">{{ 'INFORMATION_HOME_8' | translate }}</div>
          <div class="col-auto icon-container"><i class="material-icons">keyboard_arrow_right</i></div>
        </div>
      </div>
    </a>

    <a [routerLink]="['cancel']" class="padding-vertical pv16 home-list d-block border-bottom" mdbRipple>
      <div class="link-contents">
        <div><strong>{{ 'INFORMATION_HOME_9' | translate }}</strong></div>
        <div class="row">
          <div class="col information-description">{{ 'INFORMATION_HOME_10' | translate }}</div>
          <div class="col-auto icon-container"><i class="material-icons">keyboard_arrow_right</i></div>
        </div>
      </div>
    </a>

    <a href="https://www.mapfreinsurance.com/en/terms-conditions/" target="_blank" rel="noopener" class="padding-vertical pv16 home-list d-block" mdbRipple>
      <div class="link-contents">
        <div><strong>{{ 'INFORMATION_HOME_11' | translate }}</strong></div>
        <div class="row">
          <div class="col information-description">{{ 'INFORMATION_HOME_12' | translate }}</div>
          <div class="col-auto icon-container"><i class="material-icons">keyboard_arrow_right</i></div>
        </div>
      </div>
    </a>
  </div>
</div>
</div>
